import { useFormik } from 'formik';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import * as Yup from 'yup';
import { customerBundleUpdate } from '../../../api-services';

const initialState = {
  action: 'ADD',
  value: '',
  description: '',
};
const UpdateBundle = ({
  individualBundleData,
  setindividualBundleData,
  showIndividualBundle,
  setshowIndividualBundle,
}) => {
  const [initialValues, setInitialValues] = useState(initialState);
  const queryClient = useQueryClient();

  const validationSchema = Yup.object().shape({
    action: Yup.string().required('Action is required'),
    value: Yup.number().required('Value is required'),
    description: Yup.string().required('Description is required'),
  });

  const { isLoading, mutateAsync: mutateUpdate } = useMutation(
    'customerBundleUpdate',
    customerBundleUpdate,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('UserListing');
          queryClient.invalidateQueries('getBundleDetails');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    },
  );

  const handleSubmitForm = async (values) => {
    const payload = {
      ...values,
      id: individualBundleData?.id,
    };
    await mutateUpdate(payload);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });
  const handleClose = () => {
    formik.resetForm();
    setindividualBundleData({});
    setshowIndividualBundle(false);
  };
  return (
    <Modal
      size="md"
      centered
      show={showIndividualBundle}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            Update Bundle
          </h5>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Type:</label>
                <small>{individualBundleData?.bundle_type ?? 'NA'}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">
                  {individualBundleData?.bundle_type === 'CALL'
                    ? 'minutes'
                    : 'SMS'}
                </label>
                <small>{individualBundleData?.bundle ?? 'NA'}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Action</label>
                <div className="form-group input_control input_control--gap">
                  <div className="w-100">
                    <select
                      className="form-control"
                      name="action"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.action}
                    >
                      <option value="ADD">ADD</option>
                      <option value="SUBTRACT">SUBTRACT</option>
                    </select>
                    {formik.touched.action && formik.errors.action ? (
                      <div className="error_required">
                        {formik.errors.action}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Value</label>
                <div className="form-group input_control input_control--gap position-relative">
                  <div className="w-100 ">
                    <input
                      type="number"
                      step="any"
                      className="form-control"
                      placeholder="value"
                      name="value"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.value}
                    />
                    {formik.touched.value && formik.errors.value ? (
                      <div className="error_required">
                        {formik.errors.value}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="labelMove">Description</label>
                <div className="form-group input_control input_control--gap position-relative">
                  <div className="w-100 ">
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Please provide description...."
                      name="description"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.description}
                    />
                    {formik.touched.description && formik.errors.description ? (
                      <div className="error_required">
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClose()}
            disabled={isLoading}
          >
            Close
          </button>

          <button
            type="submit"
            className="btn btn-dark-blue"
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateBundle;
